import React, { useState, useEffect } from 'react';
import BOLayout from '@/pages/back-office/BOLayout';
import { useSettings } from '@/contexts/SettingsContext';
import SettingsTopBanner from '@/components/back-office/SettingsTopBanner';

function AppSettings() {
    const {
        isMenuPageEnabled,
        isHaguimModeEnabled,
        haguimName,
        toggleMenuPage,
        toggleHaguimMode,
        updateHaguimName
    } = useSettings();

    const [localMenuEnabled, setLocalMenuEnabled] = useState(isMenuPageEnabled);
    const [localHaguimEnabled, setLocalHaguimEnabled] = useState(isHaguimModeEnabled);
    const [localHaguimName, setLocalHaguimName] = useState(haguimName);

    useEffect(() => {
        setLocalMenuEnabled(isMenuPageEnabled);
        setLocalHaguimEnabled(isHaguimModeEnabled);
        setLocalHaguimName(haguimName);
    }, [isMenuPageEnabled, isHaguimModeEnabled, haguimName]);

    const handleSaveSettings = () => {
        toggleMenuPage(localMenuEnabled);
        toggleHaguimMode(localHaguimEnabled);
        updateHaguimName(localHaguimName);
        alert('Paramètres sauvegardés avec succès!');
    };

    return (
        <BOLayout>
            <SettingsTopBanner />

            <div className="mb-4 grid grid-cols-1 gap-12">
                <h1 className="text-3xl font-bold text-center mt-4">Paramètres de l'Application</h1>
            </div>

            <div className="bg-white shadow-md rounded-lg p-6 mb-6">
                <div className="mb-6">
                    <h2 className="text-xl font-semibold mb-4">Paramètres de la page d'accueil</h2>

                    <div className="flex items-center mb-4">
                        <input
                            type="checkbox"
                            id="menuPageToggle"
                            className="mr-2 h-5 w-5"
                            checked={localMenuEnabled}
                            onChange={(e) => setLocalMenuEnabled(e.target.checked)}
                        />
                        <label htmlFor="menuPageToggle" className="text-lg">
                            Activer la page Menu
                        </label>
                    </div>
                </div>

                <div className="mb-6">
                    <h2 className="text-xl font-semibold mb-4">Mode Haguim (Fêtes)</h2>

                    <div className="flex items-center mb-4">
                        <input
                            type="checkbox"
                            id="haguimModeToggle"
                            className="mr-2 h-5 w-5"
                            checked={localHaguimEnabled}
                            onChange={(e) => setLocalHaguimEnabled(e.target.checked)}
                        />
                        <label htmlFor="haguimModeToggle" className="text-lg">
                            Activer le mode Haguim
                        </label>
                    </div>

                    {localHaguimEnabled && (
                        <div className="mt-4">
                            <label htmlFor="haguimName" className="block text-lg mb-2">
                                Nom de la fête:
                            </label>
                            <input
                                type="text"
                                id="haguimName"
                                className="w-full p-2 border border-gray-300 rounded"
                                value={localHaguimName}
                                onChange={(e) => setLocalHaguimName(e.target.value)}
                                placeholder="Ex: Pessah, Rosh Hashana, etc."
                            />
                        </div>
                    )}
                </div>

                <button
                    onClick={handleSaveSettings}
                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
                >
                    Sauvegarder les paramètres
                </button>
            </div>
        </BOLayout>
    );
}

export default AppSettings; 